import { apiClient } from '@/lib/api/client'

export type OrganizationInvoiceListItemDto = {
  id: string
  number: string
  type: string // deposit | final | standalone | credit_note
  invoiceDate: string
  createdAt: string | null
  amountWithTax: number
  vatPercents: number[] | null
  isSuperseded: boolean
  supersededByInvoiceId: string | null
  supersededAt: string | null
  hasPdf: boolean
  projectId: string
  projectReference: string | null
  projectName: string | null
  customerId: string
  clientName: string | null
}

export type OrganizationInvoicesPageDto = {
  items: OrganizationInvoiceListItemDto[] | null
  totalCount: number
  // Net TTC total of the whole filtered set (credit notes are negative).
  totalAmountWithTax: number
  page: number
  pageSize: number
}

export type GetOrganizationInvoicesParams = {
  page: number
  pageSize: number
  type?: string
  from?: string
  to?: string
  q?: string
  orderBy?: 'issuedDate' | 'number' | 'amount'
  orderDir?: 'asc' | 'desc'
}

export function buildOrganizationInvoicesQuery(params: GetOrganizationInvoicesParams): URLSearchParams {
  const query = new URLSearchParams({
    page: String(params.page),
    pageSize: String(params.pageSize),
  })
  if (params.type) query.set('type', params.type)
  if (params.from) query.set('from', params.from)
  if (params.to) query.set('to', params.to)
  if (params.q && params.q.trim()) query.set('q', params.q.trim())
  if (params.orderBy) query.set('orderBy', params.orderBy)
  if (params.orderDir) query.set('orderDir', params.orderDir)
  return query
}

export async function getOrganizationInvoices(
  params: GetOrganizationInvoicesParams,
): Promise<OrganizationInvoicesPageDto> {
  const query = buildOrganizationInvoicesQuery(params)
  return apiClient.get<OrganizationInvoicesPageDto>(`/api/v2/invoices?${query.toString()}`)
}
